module.exports = __webpack_public_path__ + "static/img/agua-coco.a3cb3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/agua-coco.png
// module id = x37Q
// module chunks = 0